import { clsx } from "clsx";
import type { InputHTMLAttributes, Ref } from "react";

/** True when the caller sizes the control itself; then `w-full` must not compete with its class. */
const setsWidth = (className?: string) => /(^|\s)(w-|min-w-|max-w-|flex-1|basis-)/.test(className ?? "");

/** The prototype's field (spec §8.21): surface, strong border, accent focus ring. `compact` is the
 * 30 px small control (FRONTEND_DESIGN.md §2.4) for dense panels. */
export function Input({
  className,
  compact,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { ref?: Ref<HTMLInputElement>; compact?: boolean }) {
  return (
    <input
      className={clsx(
        "kss-control kss-field text-neutral-900 dark:text-neutral-100",
        !setsWidth(className) && "w-full",
        compact ? "h-[30px] px-2 text-[13px]" : "px-3 py-[9px] text-sm",
        className,
      )}
      {...props}
    />
  );
}
